import { inputAnatomy } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers } from "@chakra-ui/styled-system";

const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(inputAnatomy.keys);

export const inputTheme = defineMultiStyleConfig({
	baseStyle: definePartsStyle({
		field: {
			px: 4,
			py: 6,
		},
	}),
	variants: {
		outline: definePartsStyle({
			field: {
				_focus: {
					borderColor: "brand.500",
					boxShadow: "0 0 0 1px var(--chakra-colors-brand-500)",
				},
				_focusVisible: {
					borderColor: "brand.500",
					boxShadow: "0 0 0 1px var(--chakra-colors-brand-500)",
				},
			},
		}),
	},
});
